// extracted by mini-css-extract-plugin
module.exports = {"questionBox":"O2tHM","optionTitle":"ziYxb","optionDesc":"h3Lgr","infoIcon":"UAKPk"};